module.exports = __webpack_public_path__ + "static/media/section-cat-img-2.444f7fae.png";